import WithLocationHistory from "./hoc-client-component/WithLocationHistory";

export default function withLocationHistory(Component: React.JSX.Element) {
  return <WithLocationHistory Component={Component} />;
}
